import { render, staticRenderFns } from "./oaJexl.vue?vue&type=template&id=50549563&scoped=true"
import script from "./oaJexl.vue?vue&type=script&lang=js"
export * from "./oaJexl.vue?vue&type=script&lang=js"
import style0 from "./oaJexl.vue?vue&type=style&index=0&id=50549563&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50549563",
  null
  
)

export default component.exports